import React from 'react';
import PropTypes from 'prop-types';
import { Trail, Spring, animated, SpringConfig } from 'react-spring';
import styled from 'styled-components';
import ClickThroughModalWrapper from '../ClickThroughModalWrapper';
import PreviewCompatibleImage from '../PreviewCompatibleImage';

const Svg = styled.svg`
  background-color: ${(props) => props.theme.light};
  vertical-align: bottom;
`;
const PageSvg = (props) => {
  const {
    children,
    image,
    item,
    embedStyles,
    trail,
    svgProps,
    styles,
    viewBox,
    trailProps,
    springProps,
  } = props;

  return (
    <ClickThroughModalWrapper
      heading={item?.label}
      modalContent={
        image ? (
          <div>
            <PreviewCompatibleImage imageInfo={image} />
          </div>
        ) : null
      }
    >
      <Svg
        aria-hidden="true"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox={viewBox}
        xmlSpace="preserve"
        {...svgProps}
      >
        {embedStyles && <style type="text/css">{styles}</style>}
        {children[1] && trail ? (
          <Trail
            {...trailProps}
            keys={(children, i) => children.key}
            items={children}
          >
            {(item) => (styles) =>
              React.createElement(animated.g, {
                style: styles,
                children: item,
              })}
          </Trail>
        ) : (
          <Spring {...springProps}>
            {(style) => React.createElement(animated.g, { style, children })}
          </Spring>
        )}
      </Svg>
    </ClickThroughModalWrapper>
  );
};

const ReactSpringDefaults = {
  native: true,
  config: { delay: 500 },
  from: { opacity: 0, transform: 'translateY(200px)' },
  to: { opacity: 1, transform: 'translateY(0px)' },
};
PageSvg.propTypes = {
  trail: PropTypes.bool,
  embedStyles: PropTypes.bool,
  viewBox: PropTypes.string,
  // trailProps: TrailProps,
  // springProps: SpringProps,
  styles: PropTypes.string,
};
PageSvg.defaultProps = {
  trail: true,
  embedStyles: false,
  trailProps: ReactSpringDefaults,
  springProps: ReactSpringDefaults,
  styles: '',
};
export default PageSvg;
